import styled from 'styled-components';

import InputMask from 'react-input-mask';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 5px;
  width: ${props => props.width}
`

export const Label = styled.label`
  font-size: 1.27rem;
  line-height: 1.5;
  text-align: left;
  text-transform: uppercase;
  font-weight: bold;
  color: #707070;
  margin-bottom: 5px;
  @media only screen and (max-width: 768px) {
   font-size: 1rem;
  }
`

export const Input = styled(InputMask)`
  background: #DDD;
  border-radius: 5px;
  border: none;
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #707070;
  padding: 11px 10px;
  border-left: 8px solid ${ props => props.border };
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #707070;
    font-weight: bold;
    font-size: 1rem;
  }
  cursor: ${ props => props.disabled ? 'not-allowed' : 'auto' };
`
